import { TextField } from '@mui/material';
import type { NewCustomer } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import { useFormContext } from 'react-hook-form';
import { vyFormRegister } from '../../../../utils/react-hook-forms-utils';
import { CustomerViewPropertiesBlock } from '../../CustomerInfoViewEditPage/customer-info-view-edit-components/CustomerViewPropertiesBlock';
import { NetSuiteCustomersDropdown } from '../../customers-component/NetSuiteCustomersDropdown';

export const CreateCustomerNameBlock: React.FC = () => {
  const { register, formState: { errors }, control } = useFormContext<NewCustomer>();

  const taxIdRegister = vyFormRegister(register, 'taxId');
  const nameRegister = register('name');
  const externalIdRegister = vyFormRegister(register, 'externalId');

  return (
    <CustomerViewPropertiesBlock
      titleClassName='text-xl text-black font-medium'
      title='Customer Name'
    >
      <div className="group flex w-3/12 flex-col pr-6">
        <TextField
          label='Tax ID'
          placeholder="Text here"
          {...taxIdRegister}
          error={isNotNullOrUndefined(errors[taxIdRegister.name])}
          helperText={errors[taxIdRegister.name]?.message}
        />
      </div>

      <div className="group flex w-3/12 flex-col pr-6">
        <TextField
          label='Name'
          placeholder="Text here"
          {...nameRegister}
          error={isNotNullOrUndefined(errors[nameRegister.name])}
          helperText={errors[nameRegister.name]?.message}
        />
      </div>

      <div className="group flex w-3/12 flex-col pr-6">
        <TextField
          label='Alias'
          placeholder="Text here"
          {...externalIdRegister}
          error={isNotNullOrUndefined(errors[externalIdRegister.name])}
          helperText={errors[externalIdRegister.name]?.message}
        />
      </div>

      <div className="group flex w-3/12 flex-col pr-6">
        <NetSuiteCustomersDropdown
          control={control}
          showDropdown={true}
        />
      </div>
    </CustomerViewPropertiesBlock>
  );
};